import { type CtsModuleSpecsFragment } from '../../../../api/fragments/CtsModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import { CtsSettingsEmptyList, CtsSettingsTable } from './CtsSetting';

type CtsModuleTabMainProps = {
    module: CtsModuleSpecsFragment;
    openCtsSettingDrawer: () => void;
    permissions: Pick<PermissionValues, 'hasUpdatePermission'>;
};

const CtsModuleTabMain = ({ module, openCtsSettingDrawer, permissions }: CtsModuleTabMainProps) => {
    if (module.ctsSettings.length === 0) {
        return (
            <CtsSettingsEmptyList
                module={module}
                openCtsSettingDrawer={openCtsSettingDrawer}
                permissions={permissions}
            />
        );
    }

    return <CtsSettingsTable module={module} />;
};

export default CtsModuleTabMain;
